import Client from 'config/axios';

export type AdminFilterField =
  | 'id'
  | 'name'
  | 'username'
  | 'companyName'
  | 'search';

export const getAdministrators = async (
  token: string,
  limit: number,
  page: number,
  filter?: { field: AdminFilterField; value: string }
) => {
  try {
    const params = new URLSearchParams({
      limit: String(limit),
      page: String(page)
    });
    if (filter && filter.value) {
      params.append(filter.field, filter.value);
    }

    const { data } = await Client.get(`administrators?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return {
      data: data.data.docs,
      total: data.data.total ?? data.data.docs.length
    };
  } catch (response) {
    const result = response as any;
    return { errors: result.data };
  }
};
